import React, {useEffect, useState} from 'react';
import './UserReserved.css';
import Menu from "../../../Components/Menu/Menu";
import axios from "axios";
import {useNavigate} from "react-router-dom";

const UserReserved = () => {

    const navigate = useNavigate();

    const [boxNum, setBoxNum] = useState(null);
    const [boxId, setBoxId] = useState(null);
    const [reserveId, setReserveId] = useState(null);

    useEffect(() => {
        axios.get(`/api/current_shelf/`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'X-CSRFToken'
                }, withCredentials: true
            }
        )
            .then(res => {
                if (res.data.detail.length !== 0) {
                    setBoxNum(res.data.detail.name);
                    setBoxId(res.data.detail.id);
                    setReserveId(res.data.detail.id_reserve);
                }
            })
            .catch(e => {
                console.log(e);
                if (e.status === 418) {
                    navigate('/user_equipment');
                }
            })
    }, []);

    const closeBox = () => {
        axios.get(`/api/close_shelf/?shelf_id=${boxId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'X-CSRFToken'
                }, withCredentials: true
            }
        )
            .then(res => {
                console.log('Box closed');
                alert('Ящик закрыт');
            })
            .catch(e => {
                console.log(e);
            })
    }

    const openBox = () => {
        axios.get(`/api/open_shelf/?shelf_id=${boxId}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'X-CSRFToken'
                }, withCredentials: true
            }
        )
            .then(res => {
                console.log('Box opened');
                alert('Ящик открыт');
            })
            .catch(e => {
                console.log(e);
            })
    }

    const cancelBox = () => {
        if (window.confirm('Завершить бронирование ящика?')) {
            axios.get(`/api/cancel_reservation/?reservation_id=${reserveId}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Headers': 'X-CSRFToken'
                    }, withCredentials: true
                }
            )
                .then(res => {
                    console.log('Box canceled');
                    navigate('/box_reserve');
                })
                .catch(e => {
                    console.log(e);
                })
        }
    }

    const backBtn = () => {
        if (window.history.length > 3) {
            navigate(-3);
        } else {
            navigate('/box_reserve');
        }
    }

    return (
        <div className={'user-reserved-container'}>
            <Menu/>
            <div className={'user-reserved-title'}>Мой шкаф:</div>

            <div className={`user-reserved-box`}>
                <p className={'user-reserved-box-number'}>{boxNum}</p>
            </div>

            <div className={'user-reserved-button-container'}>
                <div className={'user-reserved-button u-rez-btn-close'} onClick={() => closeBox()}>Закрыть ящик</div>
                <div className={'user-reserved-button u-rez-btn-take'} onClick={() => openBox()}>Открыть ящик</div>
                <div className={'user-reserved-button u-rez-btn-end'} onClick={() => cancelBox()}>Завершить аренду</div>
                <div className={'user-reserved-button u-rez-btn-back'} onClick={() => backBtn()}>Назад</div>
            </div>
        </div>
    );
};

export default UserReserved;